import { useContext } from 'react';

import { ComponentContext, ComponentContextProps } from '@/components';

const dropUndefined = (obj: object) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => typeof v !== 'undefined'));
};

export const useComponent = (props: Partial<ComponentContextProps> = {}): ComponentContextProps => {
  const contextProps = useContext(ComponentContext);
  return { ...contextProps, ...dropUndefined(props) };
};
